export default "__VITE_PUBLIC_ASSET__2e27b30e__"